import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=4a92451d&"
import script from "./AddressList.vue?vue&type=script&async=true&lang=js&"
export * from "./AddressList.vue?vue&type=script&async=true&lang=js&"
import style0 from "./AddressList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports